/**
 * The hover / selection state a BI mark carries for the CSS in `charts-bi.css` (D566): `data-active` is ALWAYS written
 * (`true` on the mark under the pointer or the keyboard, `false` on the others) so the others can recede while one is active, and
 * `data-chosen` (via `chosenAttr`) marks the selection.
 */
import { chosenAttr, type ChartSelectProps } from './bi-kit';

/** `data-active` for a mark: `true` when it is the active one, `false` otherwise. */
export function activeAttr(active: boolean): { 'data-active': 'true' | 'false' } {
  return { 'data-active': active ? 'true' : 'false' };
}

/** `data-active` + `data-chosen` (+ `data-selectable`) for a mark identified by `value`. */
export function markAttrs(props: ChartSelectProps, value: string, active: boolean): ReturnType<typeof chosenAttr> & { 'data-active': 'true' | 'false' } {
  return { ...chosenAttr(props, value), ...activeAttr(active) };
}
